import { jsPDF } from "jspdf"
import UbuntuBase64 from "../assets/fonts/UbuntuBase64"
import UbuntuBoldBase64 from "../assets/fonts/UbuntuBoldBase64"

const EAN_L = ["0001101", "0011001", "0010011", "0111101", "0100011", "0110001", "0101111", "0111011", "0110111", "0001011"]
const EAN_G = ["0100111", "0110011", "0011011", "0100001", "0011101", "0111001", "0000101", "0010001", "0001001", "0010111"]
const EAN_R = ["1110010", "1100110", "1101100", "1000010", "1011100", "1001110", "1010000", "1000100", "1001000", "1110100"]
const EAN_PARITY = ["LLLLLL", "LLGLGG", "LLGGLG", "LLGGGL", "LGLLGG", "LGGLLG", "LGGGLL", "LGLGLG", "LGLGGL", "LGGLGL"]

const fontPayload = (asset) => {
  const value = String(asset || "")
  const separator = value.indexOf(",")
  return separator >= 0 ? value.slice(separator + 1) : value
}

const registerFonts = (doc) => {
  doc.addFileToVFS("Ubuntu-Regular.ttf", fontPayload(UbuntuBase64))
  doc.addFont("Ubuntu-Regular.ttf", "Ubuntu", "normal")
  doc.addFileToVFS("Ubuntu-Bold.ttf", fontPayload(UbuntuBoldBase64))
  doc.addFont("Ubuntu-Bold.ttf", "Ubuntu", "bold")
}

const eanBits = (ean) => {
  if (!/^\d{13}$/.test(ean)) return ""
  const parity = EAN_PARITY[Number(ean[0])]
  let bits = "101"
  for (let index = 1; index <= 6; index += 1) {
    bits += parity[index - 1] === "L" ? EAN_L[Number(ean[index])] : EAN_G[Number(ean[index])]
  }
  bits += "01010"
  for (let index = 7; index <= 12; index += 1) bits += EAN_R[Number(ean[index])]
  return `${bits}101`
}

const positionCaption = (name) => {
  const match = String(name || "").trim().match(/^(.+)-E(\d+)$/i)
  return match ? `${match[1].toUpperCase()} - Pozice ${match[2]}` : "Skladová pozice"
}

export const printStoragePositionLabel = (position) => {
  const ean = String(position?.kod_ean || "").trim()
  const name = String(position?.nazev || "").trim().toUpperCase()
  if (!/^\d{13}$/.test(ean) || !name) return false

  const doc = new jsPDF({ orientation: "landscape", unit: "mm", format: [40, 80] })
  registerFonts(doc)

  const bits = eanBits(ean)
  const barcodeX = 14
  const barcodeY = 4
  const barcodeWidth = 52
  const barcodeHeight = 14
  const moduleWidth = barcodeWidth / bits.length
  doc.setFillColor(0)
  bits.split("").forEach((bit, index) => {
    if (bit === "1") doc.rect(barcodeX + (index * moduleWidth), barcodeY, moduleWidth + 0.03, barcodeHeight, "F")
  })

  doc.setFont("Ubuntu", "normal")
  doc.setFontSize(6.5)
  doc.text(ean, 40, 21, { align: "center", charSpace: 0.7 })
  doc.setFont("Ubuntu", "bold")
  doc.setFontSize(20)
  doc.text(name, 40, 30, { align: "center" })
  doc.setFont("Ubuntu", "normal")
  doc.setFontSize(7)
  doc.text(positionCaption(name), 40, 35, { align: "center" })

  if (typeof doc.viewerPreferences === "function") doc.viewerPreferences({ PrintScaling: "None" })
  doc.autoPrint()
  const blobUrl = doc.output("bloburl")
  if (typeof window !== "undefined") window.open(blobUrl, "_blank", "noopener,noreferrer")
  return true
}
